import { render, staticRenderFns } from "./BaseInputV3.vue?vue&type=template&id=d4f21bdc&scoped=true"
import script from "./BaseInputV3.vue?vue&type=script&lang=js"
export * from "./BaseInputV3.vue?vue&type=script&lang=js"
import style0 from "./BaseInputV3.vue?vue&type=style&index=0&id=d4f21bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f21bdc",
  null
  
)

export default component.exports